import type { MatchState } from './MatchState';
import type { PlayerRuntimeState } from './PlayerRuntimeState';
import { PITCH_GEOMETRY } from './PitchGeometry';

export interface OffsideDecision {
  offside: boolean;
  receiverProgress: number;
  ballProgress: number;
  secondLastOpponentProgress: number;
}

/** Evaluates position at the instant the pass is kicked, never on reception. */
export class OffsideRule {
  evaluate(
    state: MatchState,
    passer: PlayerRuntimeState,
    receiver: PlayerRuntimeState,
    tolerance = 0.05,
  ): OffsideDecision {
    const progress = (worldX: number) => PITCH_GEOMETRY.relativeProgress(passer.teamSide, worldX);
    const receiverProgress = progress(receiver.position.x);
    const ballProgress = progress(state.ball.position.x);
    const defenders = state.players
      .filter((player) => player.teamSide !== passer.teamSide)
      .map((player) => progress(player.position.x))
      .sort((first, second) => second - first);
    const secondLastOpponentProgress = defenders[1] ?? defenders[0] ?? PITCH_GEOMETRY.length;
    return {
      offside: receiverProgress > PITCH_GEOMETRY.functionalProgress.ownHalfEnd + tolerance
        && receiverProgress > ballProgress + tolerance
        && receiverProgress > secondLastOpponentProgress + tolerance,
      receiverProgress,
      ballProgress,
      secondLastOpponentProgress,
    };
  }
}
